import { useState, useEffect } from 'react'
import { usePages } from './pages'
import { useLoading } from '@orbital/games-frontend-library'

export const useCustomLoader = (
  handleAbove: any,
  id: string,
  error: boolean,
) => {
  const enableLoading = window.location.hostname !== 'localhost'

  // const enableLoading = true
  const pages = usePages(enableLoading)
  const [isLoaded, setisLoaded] = useState(false)
  const [arePagesLoaded, duration] = useLoading(handleAbove, pages)

  useEffect(() => {
    setisLoaded(arePagesLoaded && !!id && !error)
  }, [arePagesLoaded, id, setisLoaded])

  const showLoader = !isLoaded && enableLoading

  return [showLoader, duration] as const
}
